<template>
  <div class="g-about">
    <!--<v-container grid-list-xl>-->
      <!--<v-layout row>-->
        <!--<v-flex lg3>-->
          <!--<div class="g-img-title">{{$t('about_me')}}</div>-->
        <!--</v-flex>-->
      <!--</v-layout>-->
    <!--</v-container>-->
    <!--<v-container grid-list-xl>-->
      <!--<v-layout class="d-flex ex-justify-around">-->
        <!--<v-flex>-->
          <!--<h2 class="g-about-title mb-5">{{ getLanguageName('site_info')}}</h2>-->
          <!--<p>-->
              <!--{{ getLanguageName('site_info_description')}}-->
          <!--</p>-->
        <!--</v-flex>-->
        <!--<v-flex>-->
          <!--<i class="g-about-icon"></i>-->
        <!--</v-flex>-->
      <!--</v-layout>-->
      <!--<v-layout  class="mt-60 d-flex ex-justify-around">-->
        <!--<v-flex>-->
          <!--<i class="g-about-icon2"></i>-->
        <!--</v-flex>-->
        <!--<v-flex>-->
          <!--<h2 class="g-about-title text-xs-right mb-5" >{{ getLanguageName('site_info')}}</h2>-->
          <!--<p class="text-sm-right">-->
              <!--{{ getLanguageName('site_info_description')}}-->
          <!--</p>-->
        <!--</v-flex>-->
      <!--</v-layout>-->
    <!--</v-container>-->
    <div class="video-section">
      <v-container fluid grid-list-xl pa-0>
        <v-layout row wrap>
          <v-flex lg6 xs12 py-0>
            <video-player  class="video-player-box vjs-big-play-centered"
                           ref="videoPlayer"
                           :options="playerOptions"
                           :playsinline="true">
            </video-player>
          </v-flex>
          <v-flex lg6 xs12>
            <div class="inner">
              <h2 class="g-title text-transform-none ma-0">{{ $t('about_giver') }}</h2>
              <p class="text-content mt-3">{{ $t('about_giver_text_giver_is_charity') }}</p>
              <p class="text-content mt-2">{{ $t('about_giver_text_people_need_more_charity') }}</p>
              <h5 class="g-title-sm mt-3">{{ $t('about_giver_text_what_you_gain') }}</h5>
              <ul class="about-section-list mt-3">
                <li>{{ $t('you_make_the_world_better') }}</li>
                <li>{{ $t('you_become_happier') }}</li>
                <li>{{ $t('you_nourish_oun_soul') }}</li>
                <li>{{ $t('you_will_live') }}</li>
              </ul>
              <router-link to="/about">
                <v-btn class="g-btn-default g-middle-btn m-w-250 g-up-letter ml-0 mt-4">{{ $t('categories.more')}} {{ $t('about_giver') }}</v-btn>
              </router-link>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <steps-section :loggedUser = "loggedUser"
                   :showModalButtons = "showModalButtons"
                   @openRegModal ="openRegModal" :key="updateComponentByLanguage"/>
    <!--Quotes-->
    <div class="quotes-section">
      <v-container grid-list-xl py-0>
        <swiper :options="quoteSwiper">
          <swiper-slide>
            <div class="quote-item">
              <p>{{ $t('its_not_how_much') }}</p>
              <strong>{{ $t('mother_teresa') }}</strong>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="quote-item">
              <p>{{ $t('happiness_doesnt_result') }}</p>
              <strong>{{ $t('ben_carson') }}</strong>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="quote-item">
              <p>{{ $t('you_have_not_lived') }}</p>
              <strong>{{ $t('john_bunyan') }}</strong>
            </div>
          </swiper-slide>
          <div class="swiper-pagination-2" slot="pagination"></div>
        </swiper>
      </v-container>
    </div>

    <div class="g-login-register">
      <v-parallax
              height="500"
              class="ex-parallax-img"
              :src="require('../../assets/images/parallax2Opt-min.jpg')"
      >
        <v-layout
                class="ex-parallax"
                align-center
                column
                justify-center
        >
          <v-container>
            <v-layout row justify-center v-show="!loggedUser.id && showModalButtons">
              <v-flex md7>
                <h2 class="g-title text-xs-center g-white text-transform-none">{{ $t('john_hundreds_of_happy_people') }}</h2>
              </v-flex>
            </v-layout>
            <v-form class="m20-auto" v-show="!loggedUser.id && showModalButtons">
              <v-layout>
                <v-flex class="d-flex justify-center align-center" >
                  <v-btn class="g-btn-default g-middle-btn g-up-letter m-0-15" @click="openRegModal">{{$t('sign_up')}}</v-btn>
                  <v-btn class="g-btn-main g-middle-btn g-up-letter m-0-15" @click="openLogModal">{{$t('sign_in')}}</v-btn>
                </v-flex>
              </v-layout>
            </v-form>
            <v-layout row wrap justify-center mt-60 class="gbold-gsubtitle">
              <v-flex md4 xs4>
                <p class="g-bold text-xs-center"> {{ giverInfo.usersCount }}</p>
                <p class="g-subtitle text-xs-center g-white">
                  {{ $t('community_members') }}</p>
              </v-flex>
              <v-flex md4 xs4>
                <p class="g-bold text-xs-center">{{ giverInfo.productsCount }}</p>
                <p class="g-subtitle text-xs-center g-white">
                  {{ $t('headers.gifts') }}</p>
              </v-flex>
              <v-flex md4 xs4>
                <p class="g-bold text-xs-center">{{ giverInfo.productRequestsCount }}</p>
                <p class="g-subtitle text-xs-center g-white">{{ $t('gift_recipients') }}</p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-parallax>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Steps from '../welcomePage/Steps'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
import { isLinux } from '../../helpers/main'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { mapState } from 'vuex'
Vue.use(VueAwesomeSwiper)
export default {
  name: 'About',
  props: ['settings', 'loggedUser', 'showModalButtons'],
  components: {
    videoPlayer,
    'steps-section': Steps
  },
  data: () => ({
    showImage: false,
    updateComponentByLanguage: false,
    quoteSwiper: {
      pagination: {
        el: '.swiper-pagination-2',
        clickable: true
      }
    },
    playerOptions: {
      // videojs options
      fluid: true,
      muted: false,
      controls: true,
      aspectRatio: '16:9',
      language: 'en',
      playbackRates: [0.5, 1.0, 1.5, 2.0],
      sources: [{
        type: 'video/mp4',
        src: './static/OneHumanFamily.mp4'
      }],
      poster: './static/oneHumanCover.jpg'
    }
  }),
  watch: {
    'activeLanguage': {
      handler () {
        this.updateComponentByLanguage = !this.updateComponentByLanguage
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState({
      activeLanguage: state => state.common.activeLanguage,
      giverInfo: state => state.products.giverInfo
    })
  },
  methods: {
    openRegModal () {
      this.$emit('openRegModal')
    },
    openLogModal () {
      this.$emit('openLogModal')
    },
    getLanguageName (name) {
      let value = ''
      if (this.settings.length > 0) {
        this.settings.forEach(setting => {
          if (setting.name === name) {
            value = setting.value
          }
        })
      }
      return value
    }
  },
  created () {
    if (isLinux()) {
      this.playerOptions.sources = [{
        type: 'video/webm',
        src: './static/OneHumanFamily.webm'
      }]
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../../assets/sass/desktop/mainPage.scss";
</style>



// WEBPACK FOOTER //
// src/components/welcomePage/About.vue